import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sustainability-future',
  templateUrl: './sustainability-future.component.html',
  styleUrls: ['./sustainability-future.component.css']
})
export class SustainabilityFutureComponent implements OnInit {

  water = 0;
  air = 0;
  energy = 0;
  waste = 0;
  employee = 0;
  health = 0;
  supplier = 0;
  buyerLocal = 0;
  buyerForeign = 0;

  constructor() { }

  ngOnInit(): void {
    this.waterValue();
    this.energyValue();
    this.wasteValue();
    this.employeeValue();
    this.healthValue();
    this.supplierValue();
    this.buyerLocalValue();
    this.buyerForeignValue();
  }
  
  async waterValue() {
    for(var i = 0; i < 10 + 1; i++){
      this.water = i;
      await this.delay(100);
    }
  }

  async energyValue() {
    for(var i = 0; i < 112 + 1; i++){
      this.energy = i;
      await this.delay(10);
    }
  }

  async wasteValue() {
    for(var i = 0; i < 40 + 1; i++){
      this.waste = i;
      await this.delay(25);
    }
  }

  async employeeValue() {
    for(var i = 0; i < 326 + 1; i++){
      this.employee = i;
      await this.delay(3.06);
    }
  }

  async healthValue() {
    for(var i = 0; i < 8 + 1; i++){
      this.health = i;
      await this.delay(125);
    }
  }

  async supplierValue() {
    for(var i = 0; i < 100 + 1; i++){
      this.supplier = i;
      await this.delay(10);
    }
  }

  async buyerLocalValue() {
    for(var i = 0; i < 36 + 1; i++){
      this.buyerLocal = i;
      await this.delay(28);
    }
  }

  async buyerForeignValue() {
    for(var i = 0; i < 64 + 1; i++){
      this.buyerForeign = i;
      await this.delay(16);
    }
  }

  private delay(ms: number)
  {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
